import { BaseExperienceConfig, ConfigType } from '../interfaces';
import experiences from '../data/experiences.json'

export function getExperienceById(experienceId: string): BaseExperienceConfig {
  return (experiences as ConfigType)[experienceId] || {};
}

export default experiences;
